import React from 'react';

const OtherHealthInsuranceDescription = (
  <>
    <h2 className="vads-u-font-size--h3">Report other health insurance</h2>
    <p>
      Now we’ll ask you about current health insurance policies that the
      applicants have. This helps us process payments correctly.
    </p>
    <p>
      You can also include past insurance policies that were active when any
      applicants first became eligible for CHAMPVA.
    </p>
    <p>
      <strong>Note:</strong> You can submit claims for care you received after
      the applicant became eligible up to the date you enrolled in CHAMPVA up to
      180 days after you receive your CHAMPVA welcome packet.
    </p>
  </>
);

export default OtherHealthInsuranceDescription;
